export const URL_SPRADLING_HOME = "https://www.spradling.eu"
